import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  DASHBOARD_API,
  GET_CLASSIFIED_EXPENDITURES_API,
  GET_CUSTODIAN_BALANCE_API,
  GET_PENDING_LIST_API,
  PROJECT_USERS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const managerGetPendingList = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_PENDING_LIST_API}`,
    needToken: true
  });
};

export const managerGetCustodianBalance = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_CUSTODIAN_BALANCE_API}`,
    needToken: true
  });
};

export const managerGetClassification = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_CLASSIFIED_EXPENDITURES_API}`,
    needToken: true
  });
};
